<template>
  <div class="my-3">
    <b-row class="FITSelect" align-v="center">
      <b-col :sm="labelWidth" class="text-left">
        <label :class="validationStyle" class="mb-0 align-middle">{{this.label}} <span v-if="required&&label" :class="validationState?'form-valid':'form-invalid'" style="font-size: 1rem;">*</span></label>
      </b-col>
      <b-col :sm="inputWidth">
        <b-form-select :multiple="multiple" :value="value" v-bind:class="{ disabled: disabled }" class="FITInput" :options="this.options" :disabled='this.disabled' :select-size="this.selectSize" :state="validationState" @input="change($event)"></b-form-select>
      </b-col>
    </b-row>
    <b-row align-v="center" align-h="end">
      <b-col :sm="inputWidth">
        <span class="form-invalid" v-if="validationState==false">{{errorMsg}}<br/></span>
        <!-- <span> {{validatorObject}} </br> {{validationState}}</span> 
 --><span style="display: none;">{{getRuleByField}}{{validatorObject}}</span>
      </b-col>
    </b-row>
  </div>
</template>
<script type="text/javascript">
/* eslint-disable */
import Vue from 'vue'
import { required } from 'vuelidate/lib/validators'
import FITValidationBus from './FITValidationBus';

export default {
  name: 'FITSelect',
  props: {
    label: String,
    options: {
      type: Array,
      required: true
    },
    width: Number,
    value: [String, Number, Object, Array],
    disabled: Boolean,
    selectSize: Number,
    rule: { type: Object, default: function() { return {} } },
    field: String,
    vuexObject: { type: String, default: "default" },
    vuexModule: { type: String, default: "Validation" },
    vuexMutation: { type: String, default: "setValidationResult" },
    multiple: {
      default: false,
      type: Boolean
    },

  },
  data() {
    return {
      inputWidth: this.width,
      fieldInput: this.value,
      vuexValidator: false,

    }
  },
  validations() {
    if (this.required == true) {
      return {
        fieldInput: { required },
      }
    } else {
      return {
        fieldInput: {}
      }
    }
  },
  watch: {
    fieldInput: {
      deep: true,
      handler(val) {
        // console.log("FITSelect: "+val);
        this.$emit('input', val);
        this.$emit('validation', this.validationState);

      }
    },
    value(val) {
      this.change(val);
    }
  },
  mounted() {
    this.labelCheck(this.label);
    if (this.fieldInput) {
      this.$v.fieldInput.$touch();
    }
    // onListen Reset 
    FITValidationBus.$on('reset', (value) => {
      if (value) {
        // console.log("onEmit");
        if (this.$v) {
          this.$nextTick(() => { this.$v.$reset() })
        }
      }
    });

    // onListen dirty 
    FITValidationBus.$on('dirty', (value) => {
      if (value) {
        if (value == this.vuexObject) {
          // console.log("onDirty");
          this.$nextTick(() => { this.$v.fieldInput.$touch() });
          this.$emit('validation', this.validationState);

        }
      }
    });

    // Initial Dirty
    this.$nextTick(() => { this.$v.fieldInput.$reset() })
  },
  computed: {
    getRuleByField() {
      let rules = this.$store.getters[`${this.vuexModule}/getRuleByField`];
      let result = rules(this.field);
      if (Object.keys(result).length > 0) {
        this.vuexValidator = true;
      } else {
        this.vuexValidator = false;
      }
      return result;
    },
    required() {
      if (this.vuexValidator) {
        return true;
      }

      if (this.rule.required == true) {
        return true;
      } else {
        return false;
      }
    },
    getValidationFinalCheck() {
      if (!this.vuexModule) {
        return false;
      }
      return this.$store.getters[`${this.vuexModule}/getValidationFinalCheck`];
    },
    errorMsg() {
      return this.$t('validation.errorMsg.required');
    },
    validatorObject() {
      return this.$v.fieldInput;
    },
    validationState() {
      if ((!this.required) || (this.disabled)) {
        return null;
      }
      if (this.getValidationFinalCheck) {
        this.$v.fieldInput.$touch();
      }
      // Valdiation State Check
      let dirty = this.$v.fieldInput.$dirty;
      let invalid = this.$v.fieldInput.$invalid;
      let state = null;
      if (!dirty) {
        state = null;
      } else {
        if (invalid) {
          state = false;
        } else {
          if (!this.fieldInput) {
            state = null;
          } else {
            state = true;
          }
        }
      }
      // Update to Vuex
      if (this.field) {
        this.$store.commit(`${this.vuexModule}/${this.vuexMutation}`, {
          object: this.vuexObject,
          field: this.field,
          result: state,
        });
      }
      return state;
    },
    validationStyle() {
      if (this.validationState == null) { return; }
      if (this.validationState == true) { return 'form-valid'; }
      if (this.validationState == false) { return 'form-invalid'; }
    },
    labelWidth() {
      return 12 - this.inputWidth;
    }
  },
  methods: {
    labelCheck(label) {
      if (!label) {
        this.inputWidth = 12;
      }
    },
    change(event) {
      this.$v.fieldInput.$model = event;
    }
  }
}

</script>
<style type="text/css">


</style>



// WEBPACK FOOTER //
// src/components/Form/FITSelect.vue